<template>
  <div class="view">
    <div class="view__main">
      <!--      <div class="view__title">Настройки аккаунта</div>-->

      <Tabs class="view__main__tabs" :value="activeTab" @input="(val) => (activeTab = val)">
        <Tab
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab"
          class="view__main__tab"
          :class="{ 'view__main__tab--active': activeTab.key == tab.key }"
        >
          {{ tab.name }}
        </Tab>
      </Tabs>

      <div class="view__columns">
        <div v-if="activeTab.name === 'Основное'" class="view__column view__column--1">
          <div class="view__column-title">Общая информация</div>

          <ProfileBlock class="view__profile-block" />

          <GeneralInfoBlock />
        </div>

        <div v-if="activeTab.name === 'Пароль'" class="view__column view__column--2">
          <div class="view__column-title">Изменить пароль</div>

          <div class="view__column-subtitle">
            Пароль должен содержать цифры, прописные и строчные буквы и состоять хотя бы из 7 символов
          </div>

          <PasswordForm />
        </div>

        <div v-if="activeTab.name === 'Уведомления'" class="view__column view__column--3">
          <!--          <div class="view__column-title">Уведомления</div>-->

          <!--          <div class="view__column-subtitle">Разрешите получение уведомлений в браузере</div>-->

          <NotificationsBlock ref="notificationsBlock" />

          <NotificationChannels ref="notificationChannels" :class="{ row: isWrapped }" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileBlock from "@/components/UserSettings/ProfileBlock.vue";
import GeneralInfoBlock from "@/components/UserSettings/GeneralInfoBlock.vue";
import PasswordForm from "@/components/UserSettings/PasswordForm.vue";
import NotificationsBlock from "@/components/UserSettings/NotificationsBlock.vue";
import Tab from "@/components/common/Tab.vue";
import Tabs from "@/components/common/Tabs.vue";
import NotificationChannels from "@/components/UserSettings/NotificationChannels.vue";

export default {
  name: "UserSettingsView",

  components: {
    NotificationChannels,
    Tabs,
    Tab,
    ProfileBlock,
    GeneralInfoBlock,
    PasswordForm,
    NotificationsBlock,
  },

  data: () => ({
    activeTab: { key: "main", name: "Основное" },
    tabs: [
      { key: "main", name: "Основное" },
      { key: "password", name: "Пароль" },
      { key: "notify", name: "Уведомления" },
    ],
    isWrapped: false,
  }),

  mounted() {
    // this.initObservers();
  },

  methods: {
    initObservers() {
      // Наблюдаем за контейнером и блоками
      const elementsToObserve = [
        this.$refs.container,
        this.$refs.notificationsBlock?.$el,
        this.$refs.notificationChannels?.$el,
      ].filter(Boolean);

      elementsToObserve.forEach((element) => {
        const observer = new ResizeObserver(this.checkWrap);
        observer.observe(element);
        this.observers.push(observer);
      });
    },

    checkWrap() {
      this.$nextTick(() => {
        const container = this.$refs.container;
        const block = this.$refs.notificationsBlock?.$el;
        const channels = this.$refs.notificationChannels?.$el;

        if (!container || !block || !channels) return;

        const blockRect = block.getBoundingClientRect();
        const channelsRect = channels.getBoundingClientRect();

        // Проверяем положение блоков относительно друг друга
        this.isWrapped = channelsRect.top > blockRect.top + blockRect.height / 2;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.view {
  height: 100%;
  padding: 24px;

  &__main {
    min-height: 100%;
    padding: 20px 40px;

    &__tabs {
      //width: 312px;
      height: 52px;
      margin-bottom: 30px;
      //box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
    }

    &__tab {
      display: flex;
      align-items: center;
      padding: 0 20px;
      color: $grey-600;
      cursor: pointer;
      transition: color $short;
      user-select: none;

      &--active {
        color: $black;
      }
    }
  }

  &__title {
    margin-bottom: 74px;
    font-size: 28px;
    font-weight: 500;
  }

  &__profile-block {
    display: flex;
    margin-bottom: 56px;
  }

  &__columns {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__column {
    &--1,
    &--2 {
      width: 312px;
      margin-right: 42px;
      margin-bottom: 42px;
    }

    &--3 {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 80px;
    }
  }

  &__column-title {
    margin-bottom: 20px;
    color: $grey-600;
    font-size: 18px;
    font-weight: 500;
    text-transform: uppercase;
  }

  &__column-subtitle {
    margin-bottom: 36px;
    color: $grey-600;
    font-size: 12px;
  }

  @media (max-width: 1264px) {
    &__main {
      padding: 40px;
    }
  }

  @media (max-width: 600px) {
    padding: 0;

    &__title {
      margin-bottom: 40px;
      font-size: 24px;
    }

    &__main {
      padding: 24px;
      box-shadow: none;
    }
  }
}
</style>
